import { BrowserRouter, Routes, Route } from "react-router-dom"
import MainPage from "@/pages/MainPage.tsx";
import ProductListPage from "@/pages/ProductListPage.tsx";
import ProductDetailPage from "@/pages/ProductDetailPage.tsx";
import CartPage from "@/pages/CartPage.tsx";
import OrderPage from "@/pages/OrderPage.tsx";
import SignupPage from "@/pages/SignupPage.tsx";
import LoginPage from "@/pages/LoginPage.tsx";
import MyPage from "@/pages/MyPage.tsx";
import AdminDashboardPage from "@/pages/admin/AdminDashboardPage.tsx";
import AdminProductPage from "@/pages/admin/AdminProductPage.tsx";
import AdminOrderPage from "@/pages/admin/AdminOrderPage.tsx";
import AdminProductCreatePage from "@/pages/admin/AdminProductCreatePage.tsx";
import AdminLoginPage from "@/pages/admin/AdminLoginPage.tsx";
import AdminProtectedRoute from "@/components/admin/AdminProtectedRoute.tsx";
import AdminPublicRoute from "@/components/admin/AdminPublicRoute.tsx";
import { AdminAuthProvider } from "./contexts/AdminAuthContext";
import AdminProductDetailPage from "@/pages/admin/AdminProductDetailPage.tsx";
import AdminProductEditPage from "@/pages/admin/AdminProductEditPage.tsx";
import AdminMemberDetailPage from "@/pages/admin/AdminMemberDetailPage.tsx";
import AdminMemberPage from "@/pages/admin/AdminMemberPage.tsx";
import AdminMemberCreatePage from "@/pages/admin/AdminMemberCreatePage.tsx";
import AdminOrderDetailPage from "@/pages/admin/AdminOrderDetailPage.tsx";
import AdminBannerFormPage from "@/pages/admin/AdminBannerFormPage.tsx";
import AdminBannerPage from "@/pages/admin/AdminBannerPage.tsx";
import {AuthProvider} from "@/contexts/AuthContext.tsx";
import OrderDetailPage from "@/pages/OrderDetailPage.tsx";
import AdminReviewPage from "@/pages/admin/AdminReviewPage.tsx";
import CategoryListPage from "@/pages/CategoryListPage.tsx";
import AdminCategoryPage from "@/pages/admin/AdminCategoryPage.tsx";
import AdminPartnerPage from "@/pages/admin/AdminPartnerPage.tsx";
import AdminMapPage from "@/pages/admin/AdminMapPage.tsx";
import AdminOrderCreatePage from "@/pages/admin/AdminOrderCreatePage.tsx";
import TermsPage from "@/pages/TermsPage.tsx";
import PrivacyPage from "@/pages/PrivacyPage.tsx";
import RefundPage from "@/pages/RefundPage.tsx";
import PaymentCallbackPage from "@/pages/PaymentCallbackPage.tsx";
import AdminPaymentCallbackPage from "@/pages/admin/AdminPaymentCallbackPage.tsx";
import GuestOrderLookupPage from "@/pages/GuestOrderLookupPage.tsx";
import CustomerCenterPage from "@/pages/cs/CustomerCenterPage.tsx";
import InquiryWritePage from "@/pages/cs/InquiryWritePage.tsx";
import InquiryListPage from "@/pages/cs/InquiryListPage.tsx";
import AdminInquiryPage from "@/pages/admin/AdminInquiryPage.tsx";

// 💡 1. 추가: 공지사항 관련 페이지 import
import AdminNoticePage from "@/pages/admin/AdminNoticePage.tsx";
import AdminNoticeFormPage from "@/pages/admin/AdminNoticeFormPage.tsx";

function App() {

  return (
    <BrowserRouter>
      <AuthProvider>
        <AdminAuthProvider>

          <Routes>
            <Route path="/" element={<MainPage />} />
            <Route path="/products" element={<ProductListPage />} />
            <Route path="/product/:id" element={<ProductDetailPage />} />
            <Route path="/cart" element={<CartPage />} />
            <Route path="/order" element={<OrderPage />} />
            <Route path="/login" element={<LoginPage />} />
            <Route path="/signup" element={<SignupPage />} />
            <Route path="/mypage" element={<MyPage />} />
            <Route path="/categories" element={<CategoryListPage />} />

            {/* 💡 이용약관 라우트 추가 */}
            <Route path="/terms" element={<TermsPage />} />
            <Route path="/privacy" element={<PrivacyPage />} />
            <Route path="/refund" element={<RefundPage />} />

            <Route path="/guest/order" element={<GuestOrderLookupPage />} />

            {/*고객센터*/}
            <Route path="/cs" element={<CustomerCenterPage />} />

            {/*1:1 문의*/}
            <Route path="/cs/inquiry" element={<InquiryWritePage />} />
            <Route path="/cs/inquiries" element={<InquiryListPage />} />

            {/*모바일 결제*/}
            <Route path="/payment/callback" element={<PaymentCallbackPage />} />
            <Route
              path="/order/:orderNo"
              element={<OrderDetailPage />}
            />

            <Route
              path="/admin/login"
              element={
                <AdminPublicRoute>
                  <AdminLoginPage />
                </AdminPublicRoute>
              }
            />

            <Route
              path="/admin"
              element={
                <AdminProtectedRoute>
                  <AdminDashboardPage />
                </AdminProtectedRoute>
              }
            />

            <Route
              path="/admin/products"
              element={
                <AdminProtectedRoute>
                  <AdminProductPage />
                </AdminProtectedRoute>
              }
            />

            <Route
              path="/admin/products/new"
              element={
                <AdminProtectedRoute>
                  <AdminProductCreatePage />
                </AdminProtectedRoute>
              }
            />

            <Route
              path="/admin/products/:id"
              element={
                <AdminProtectedRoute>
                  <AdminProductDetailPage />
                </AdminProtectedRoute>
              }
            />

            <Route
              path="/admin/products/:id/edit"
              element={
                <AdminProtectedRoute>
                  <AdminProductEditPage />
                </AdminProtectedRoute>
              }
            />

            <Route
              path="/admin/categories"
              element={
                <AdminProtectedRoute>
                  <AdminCategoryPage />
                </AdminProtectedRoute>
              }
            />

            {/* 회원 관리 목록 라우트 */}
            <Route
              path="/admin/members"
              element={
                <AdminProtectedRoute>
                  <AdminMemberPage />
                </AdminProtectedRoute>
              }
            />

            {/* 회원 관리 상세 라우트 */}
            <Route
              path="/admin/members/:id"
              element={
                <AdminProtectedRoute>
                  <AdminMemberDetailPage />
                </AdminProtectedRoute>
              }
            />

            <Route
              path="/admin/members/new"
              element={
                <AdminProtectedRoute>
                  <AdminMemberCreatePage />
                </AdminProtectedRoute>
              }
            />

            <Route
              path="/admin/orders"
              element={
                <AdminProtectedRoute>
                  <AdminOrderPage />
                </AdminProtectedRoute>
              }
            />

            <Route
              path="/admin/orders/:id"
              element={
                <AdminProtectedRoute>
                  <AdminOrderDetailPage />
                </AdminProtectedRoute>
              }
            />

            <Route
              path="/admin/orders/create"
              element={
                <AdminProtectedRoute>
                  <AdminOrderCreatePage />
                </AdminProtectedRoute>
              }
            />

            <Route
              path="/admin/reviews"
              element={
                <AdminProtectedRoute>
                  <AdminReviewPage />
                </AdminProtectedRoute>
              }
            />

            {/* 배너 관리 목록 */}
            <Route
              path="/admin/banners"
              element={
                <AdminProtectedRoute>
                  <AdminBannerPage />
                </AdminProtectedRoute>
              }
            />

            {/* 신규 배너 등록 */}
            <Route
              path="/admin/banners/new"
              element={
                <AdminProtectedRoute>
                  <AdminBannerFormPage />
                </AdminProtectedRoute>
              }
            />

            {/* 기존 배너 수정 */}
            <Route
              path="/admin/banners/:id"
              element={
                <AdminProtectedRoute>
                  <AdminBannerFormPage />
                </AdminProtectedRoute>
              }
            />

            {/*화원 관리*/}
            <Route
              path="/admin/partners"
              element={
                <AdminProtectedRoute>
                  <AdminPartnerPage />
                </AdminProtectedRoute>
              }
            />

            {/*map*/}
            <Route
              path="/admin/partners/map"
              element={
                <AdminProtectedRoute>
                  <AdminMapPage />
                </AdminProtectedRoute>
              }
            />

            <Route
              path="/admin/payment/callback"
              element={
                <AdminProtectedRoute>
                  <AdminPaymentCallbackPage />
                </AdminProtectedRoute>
              }
            />

            {/* 💡 2. 고객센터 (CS) 관리자 라우트 추가 */}
            <Route
              path="/admin/cs/inquiries"
              element={
                <AdminProtectedRoute>
                  <AdminInquiryPage />
                </AdminProtectedRoute>
              }
            />

            {/* 공지사항 목록 */}
            <Route
              path="/admin/cs/notices"
              element={
                <AdminProtectedRoute>
                  <AdminNoticePage />
                </AdminProtectedRoute>
              }
            />

            {/* 공지사항 등록 및 수정 */}
            <Route
              path="/admin/cs/notices/:noticeId"
              element={
                <AdminProtectedRoute>
                  <AdminNoticeFormPage />
                </AdminProtectedRoute>
              }
            />

          </Routes>

        </AdminAuthProvider>
      </AuthProvider>
    </BrowserRouter>
  )
}

export default App